import React, { useEffect, createElement } from 'react';
import { CURRENT_PRICE_USD } from '../utils/currency';
const PIXEL_ID = '1012201387645029';
export const MetaPixel = () => {
  useEffect(() => {
    if ((window as any).fbq) return;
    (function (f: any, b: any, e: any, v: any, n?: any, t?: any, s?: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      s ? s.parentNode.insertBefore(t, s) : b.head.insertBefore(t, b.head.firstChild);
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    (window as any).fbq('init', PIXEL_ID);
    (window as any).fbq('track', 'PageView');
  }, []);
  return null;
};
// Evento AddToCart para botones de compra
export const trackAddToCart = () => {
  if (typeof window !== 'undefined' && (window as any).fbq) {
    ;
    (window as any).fbq('track', 'AddToCart', {
      content_name: 'Guía Contra el Mal de Ojo',
      content_category: 'Ebook',
      content_ids: ['46923986239723'],
      content_type: 'product',
      value: CURRENT_PRICE_USD,
      currency: 'USD'
    });
  }
};